import glam from 'glamorous';
import { Colors } from 'module/View/Common';

type WrapperProps = {
  adminBar: boolean;
};

export const Wrapper = glam.div<WrapperProps>(p => ({
  background: Colors.white,
  flex: 1,
}));

type ContentWrapperProps = {
  margins: [number, number, number, number];
  width: number;
};

export const ContentWrapper = glam.div<ContentWrapperProps>(p => ({
  position: 'relative',
  margin: p.margins.map(v => `${v}px`).join(' '),
  width: p.width,
  overflow: 'hidden',
  transitionDuration: '0.3s',
}));



// WEBPACK FOOTER //
// ./src/module/View/Main/MainLayout/MainLayout.s.ts